import { call, put, takeLatest } from 'redux-saga/effects';
import {
  fetchSuppliersStart,
  fetchSuppliersSuccess,
  fetchSuppliersFailure,
} from './slice';
import { getLocationData } from './query';

function* fetchSuppliersSaga(action) {
  try {
    const data = yield call(getLocationData, action.payload);
    yield put(fetchSuppliersSuccess(data));
  } catch (error) {
    yield put(fetchSuppliersFailure(error.message || 'Error fetching supplier data'));
  }
}

export default function* suppliersSaga() {
  yield takeLatest(fetchSuppliersStart.type, fetchSuppliersSaga);
}
